import moment from 'moment'

export function formatDate(value) {
  return moment(value).format('YYYY-MM-DD')
}
export function formatDateTime(value) {
  return moment(value).format('YYYY-MM-DD hh:mm')
}
export function NextDateTime(value) {
  const endTime = new Date(value).getTime() / 1000 - parseInt(new Date().getTime() / 1000)
  const timeDay = Math.ceil(endTime / 60 / 60 / 24)
  if (timeDay && timeDay > 0) {
    return timeDay
  } else {
    return 0
  }
}
export function telEllipsis(value) {
  let str = ''
  let tel = String(value)
  str = tel.slice(0, 3) + '****' + tel.slice(7, 11)
  return str
}
export function formatDate2(currentTime, refreshTime) {
  currentTime = Number(currentTime)
  refreshTime = Number(refreshTime)
  const stamp = Math.ceil((currentTime - refreshTime) / 1000)
  if (stamp <= 60) {
    return '1分钟前'
  } else if (stamp > 60 && stamp <= 3600) {
    return Math.ceil(stamp / 60) + '分钟前'
  } else if (stamp > 3600 && stamp <= 3600 * 24) {
    return Math.ceil(stamp / 3600) + '小时前'
  } else if (3600 * 24 < stamp && stamp <= 3600 * 24 * 10) {
    return Math.ceil(stamp / (3600 * 24)) + '天前'
  } else if (3600 * 24 * 10 < stamp) {
    let date = new Date(refreshTime)
    let year = date.getFullYear()
    let month = date.getMonth() + 1 // js从0开始取
    let day = date.getDate()
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    return year + '-' + month + '-' + day
  }
}

export function beforeTime(value) {
  let time = Date.parse(new Date())
  let num = time - value
  let getMin = Math.floor(num / 1000 / 60) // 分钟
  let getHour = Math.floor(num / 1000 / 60 / 60) // 小时
  let getDay = Math.floor(num / 1000 / 60 / 60 / 24) // 天
  let time1 = new Date(value)
  var m = time1.getMonth() + 1
  var d = time1.getDate()
  var y = time1.getFullYear()

  if (m < 10) {
    m = '0' + m
  }
  if (d < 10) {
    d = '0' + d
  }
  let date = m + '-' + d
  if (getMin < 60) {
    if (getMin < 1) {
      return '1分钟前'
    }
    return getMin + '分钟前'
  } else if (getHour < 24) {
    return getHour + '小时前'
  } else if (getDay < 10) {
    return getDay + '天前'
  } else {
    return y + '-' + date
  }
}

 // 格式化:工程专业显示选择的最末级
 export function formattingEngineering(val){
  if(!val) return '/'
  if(val.includes('|')){
    let strArr =  val.split('|')
    return strArr.splice(0,3).join('/')
  }
  if(val.includes(',')){
    let strArr =  val.split(',')
    return strArr.splice(0,3).join('、')
  }
  return val
}

// 格式化:工作区域使用
export function formattingServiceAreaName(val){
 if(!val) return '/'
 if(val.includes('|')){
   let strArr =  val.split('|')
   return strArr.join('/')
 }
 return val
}


// 格式化：自定义薪资范围
export function formattingSalary(val){
  if(!val) return
  let strArr = val.split('-')
  if(strArr[0]==strArr[1]) return strArr[0]
  if(!strArr[0] || !strArr[1]) return strArr[0] || strArr[1]
  return val
}

// 格式化：【临时用工详情页】标题的工种最多显示 n 个
export function formattingWorkTypeName(val,n){
  if(!val) return
  let strArr = val.split(',')
  if(strArr.length>n)  return strArr.splice(0,n).join(',')
  return val
}

//脱敏联系人
export function formatContactName(val){
  if(!val) return
  if(val.length > 2){
    return val.substr(0, 1) + '*'+ val.substr(-1)
  }else if(val.length==1){
    return val
  }else{
    return val.substr(0, 1) + '*'
  }
}